import { Luminous, LuminousGallery } from "luminous-lightbox";
import checkIcon from "@icons/check.svg";
import { on } from "../../helpers/dom-manipulation/delegate";
import { slideDown, slideUp } from "../../helpers/dom-manipulation/animation";

document.querySelectorAll(".buy-box .add-to-cart-btn").forEach((btn) => {
    btn.addEventListener("click", (event) => {
        event.preventDefault();

        // @todo jQuery's `.parents()` always returns a jQuery object, so the
        // original `if ($(this).parents(".price-chooser"))` check is always
        // truthy regardless of whether an ancestor `.price-chooser` actually
        // exists - this always checks the sibling radio of the nearest
        // ancestor `<label>`, price-chooser or not. Ported as-is.
        const label = btn.closest("label");
        if (label) {
            const sibling = Array.from(
                label.parentElement?.children ?? [],
            ).find((el) => el !== label && el instanceof HTMLInputElement);
            if (sibling instanceof HTMLInputElement) {
                sibling.checked = true;
            }
        }

        if (label?.classList.contains("s-option")) {
            luxPopup.popupShow("lux-modal-normal-price");
            return;
        }

        if (label?.classList.contains("g-option")) {
            luxPopup.popupShow("lux-modal-guest-price");
            return;
        }

        addToCart(true, btn);
    });
});

const luxBox = document.querySelector(".lux-buy-box.member");
const addToCartBtn = luxBox?.querySelector(".add-to-cart-btn");

if (luxBox && addToCartBtn) {
    addToCartBtn.addEventListener("click", (e) => {
        e.preventDefault();

        let checked = luxBox.querySelector(
            "input[name='price-selector']:checked",
        );

        if (checked) {
            const label = luxBox.querySelector(`label[for="${checked.id}"]`);

            if (label?.classList.contains("s-option")) {
                luxPopup.popupShow("lux-modal-normal-price");
                return;
            }

            if (label?.classList.contains("g-option")) {
                luxPopup.popupShow("lux-modal-guest-price");
                return;
            }
        }

        addToCart(undefined, addToCartBtn);
    });
}

const buyBoxModal = document.getElementById("lux-modal-buy-box-non-member");

/**
 * Add the current product to the cart, optionally showing a price-choice modal first.
 *
 * @param {any} [showModal] - Whether to show the modal.
 * @param {Element} [clickedBtn] - The add-to-cart button that was clicked, so feedback is scoped to it.
 * @returns {void}
 */
function addToCart(showModal, clickedBtn) {
    if (showModal === undefined) {
        showModal = true;
    }

    //NGK: Used for tracking
    if (window.location.hash) {
        const hash = window.location.hash.substring(1);
        const productPriceRaw = window.PRODUCTPRICE;
        //Just a simple error prevention.
        const productPrice = parseFloat(
            productPriceRaw === "" ? "0" : productPriceRaw,
        );
        window._gaq = window._gaq || [];
        switch (hash) {
            case "trck_rs": //similarity
                _gaq.push([
                    "_trackEvent",
                    "Recommendation Tracking",
                    "addedToCart",
                    "Recommendation Similarity",
                    productPrice,
                ]);
                break;
            case "trck_rsl": //shelf life
                _gaq.push([
                    "_trackEvent",
                    "Recommendation Tracking",
                    "addedToCart",
                    "Recommendation Shelf Life",
                    productPrice,
                ]);
                break;
            case "trck_obw": //often bought with
                _gaq.push([
                    "_trackEvent",
                    "Recommendation Tracking",
                    "addedToCart",
                    "Recommendation Often Bought With",
                    productPrice,
                ]);
                break;
            default:
        }
    }

    const checkedRadio = /** @type {HTMLInputElement | null} */ (
        document.querySelector("input[name='price-selector']:checked")
    );

    let membersprice = 0;
    if (checkedRadio?.value === "membersprice") {
        membersprice = 1;
        document.querySelectorAll(".product-text-membership").forEach((el) => {
            if (el instanceof HTMLElement) el.style.display = "";
        });
    }

    let btn = clickedBtn ?? null;

    if (!btn) {
        const checkedId = checkedRadio?.id;

        if (checkedId) {
            btn = document.querySelector(
                `label[for="${checkedId}"] .add-to-cart-btn`,
            );
        }
    }

    if (!btn) {
        btn = document.querySelector(".add-to-cart-btn");
    }

    const feedbackBtn = btn;

    basket.addProduct(window.PRODUCTSLUG, membersprice, () => {
        if (!feedbackBtn) return;

        feedbackBtn.innerHTML = `<img src="${checkIcon}" alt="" class="svg-filter-white" style="width: 1rem">`;

        setTimeout(() => {
            feedbackBtn.innerHTML = window.TEXT95;
        }, 4000);
    });

    if (buyBoxModal) {
        luxPopup.popupClose(buyBoxModal);
    }

    const upsellContainer = document.querySelector(".upsell-container");

    if (upsellContainer instanceof HTMLElement) {
        slideDown(upsellContainer);

        setTimeout(() => {
            const headerHeight = parseFloat(
                getComputedStyle(document.body).getPropertyValue(
                    "--headerHeight",
                ),
            );

            const top =
                upsellContainer.getBoundingClientRect().top +
                window.scrollY -
                headerHeight;

            window.scrollTo({
                top,
                behavior: "smooth",
            });
        }, 250);
    }
}

/**
 * Bind the click handler that closes the upsell container.
 *
 * @returns {void}
 */
function closeUpsell() {
    document.querySelector(".close-upsell")?.addEventListener("click", () => {
        const upsell = document.querySelector(".upsell-container");
        if (upsell instanceof HTMLElement) {
            slideUp(upsell);
        }
    });
}

const options = {
    onOpen() {
        document.getElementById("bodyholder")?.classList.add("lightbox-open");
    },
    onClose() {
        document
            .getElementById("bodyholder")
            ?.classList.remove("lightbox-open");
    },
};

on(
    document.body,
    "click",
    "#lux-modal-normal-price button:not(.lux-popup-close), #lux-modal-guest-price button:not(.lux-popup-close)",
    (event, matched) => {
        const option = /** @type {HTMLElement} */ (matched).dataset.option;

        if (option === "f-option") {
            /** @type {HTMLElement | null} */ (
                document.getElementById("f-option")
            )?.click();
            addToCart(true);
        } else if (option === "close") {
            return;
        } else {
            addToCart(false);
        }
    },
);

document.querySelector("select.variants")?.addEventListener("change", (e) => {
    window.location.href = /** @type {HTMLSelectElement} */ (e.target).value;
});

let productGalleryItems = document.querySelectorAll(
    ".product-gallery, .lux-product-gallery-open",
);

if (productGalleryItems !== null) {
    new LuminousGallery(
        productGalleryItems,
        { arrowNavigation: true },
        options,
    );
}

document.querySelector(".thumbImage")?.addEventListener("click", (event) => {
    const thumb = /** @type {HTMLImageElement} */ (event.currentTarget);
    const productImage = /** @type {HTMLImageElement | null} */ (
        document.getElementById("productImage")
    );
    const image360 = document.getElementById("product360Image");

    if (productImage) {
        productImage.src = thumb.getAttribute("src") ?? "";
        productImage.style.display = "";
    }

    if (image360 instanceof HTMLElement) {
        image360.setAttribute("style", "display:none !important");
        image360.style.display = "none";
    }
});

document.querySelector(".thumb360Image")?.addEventListener("click", () => {
    const image360 = document.getElementById("product360Image");
    const productImage = document.getElementById("productImage");

    if (image360 instanceof HTMLElement) {
        image360.style.display = "";
    }

    if (productImage instanceof HTMLElement) {
        productImage.style.display = "none";
    }
});

const upsellContainer = document.querySelector(".upsell-container");
if (upsellContainer instanceof HTMLElement) {
    upsellContainer.style.height = "auto";
    upsellContainer.style.overflow = "initial";
    upsellContainer.style.display = "none";
}

closeUpsell();

document.querySelectorAll(".price-chooser .lux-radio").forEach((radio) => {
    radio.addEventListener("click", () => {
        radio.classList.add("active");
        radio.classList.remove("not-active");

        Array.from(radio.parentElement?.children ?? [])
            .filter(
                (sibling) =>
                    sibling !== radio &&
                    sibling.classList.contains("lux-radio"),
            )
            .forEach((sibling) => {
                sibling.classList.remove("active");
                sibling.classList.add("not-active");
            });

        let ancestor = radio.parentElement;
        while (ancestor) {
            ancestor.classList.remove("not-active");
            ancestor = ancestor.parentElement;
        }
    });
});

const luxProductIntro = document.querySelector(".lux-product-intro");
const luxProductDescription = document.querySelector(
    ".lux-product-description",
);

if (luxProductIntro && luxProductDescription) {
    luxProductIntro
        .querySelector(".lux-product-read-more")
        ?.addEventListener("click", function (e) {
            e.preventDefault();

            luxProductIntro.classList.add("d-none");
            luxProductDescription.classList.add("d-block");
        });
}
